<template>
  <main class="page page-settings">
    <PageToolbar
      :moreMenuItems="[
        [
          {
            text: 'Share Collection',
            share: shareData
          },
          {
            text: 'Edit Collection in Shopify',
            url: 'javascript:void(0);' // need from backend
          },
          {
            text: 'View Live Collection',
            url: 'javascript:void(0);' // need from backend
          }
        ],
        [
          {
            text: 'Settings',
            url: '/settings'
          },
          {
            text: 'Help',
            url: '/help'
          }
        ]
      ]"
      :showShareButton="false"
      :showSearchButton="false"
      :showMoreButton="false"
      :showBackButton="true"
      v-on:back-button-click="handleToolbarBackButtonClick"
    />
    <h1 class="settings-title">Settings.</h1>
    <div class="settings-row">
      <div class="settings-eyebrow">Your Plan</div>
      <h2 class="settings-headline">{{ plan }}</h2>

      <a class="settings-connect-btn" target="_parent"
        :href="appsUrl"
      >Manage</a>
    </div>
    <div class="settings-row">
      <div class="settings-eyebrow">Email will be sent to: <a class="email-link" :href="'mailto:' + email">{{email}}</a></div>
      <h2 class="settings-headline">Daily Summary Email</h2>
      <button class="settings-pill" @click="toggleSendDailyEmail">
        <Pill :isActive="sendDailyEmail" />
      </button>
    </div>
    <div class="settings-row">
      <div class="settings-eyebrow">Google Analytics</div>

      <h2 class="settings-headline"
        v-if="gaIntegration && !gaIntegration.connected"
      >Not Connected</h2>
      <a class="settings-connect-btn"
        v-if="gaIntegration && !gaIntegration.connected"
        :href="gaIntegration._links.authorize_url.href"
      >Connect</a>

      <h2 class="settings-headline"
        v-if="gaIntegration && gaIntegration.connected"
      >Connected</h2>
      <button class="settings-connect-btn"
        v-if="gaIntegration && gaIntegration.connected"
        @click="gaSetShow(true)"
      >Update</button>

    </div>

    <connect
      :integration="gaIntegration"
      :show="gaShow"
      @closed="gaSetShow(false)"
    ></connect>
  </main>
</template>

<script>
import axios from 'axios'
import { mapActions, mapMutations, mapState } from 'vuex'

import Connect from '@/components/Connect'
import PageToolbar from '@/components/PageToolbar'
import Pill from '@/components/Pill'

export default {
  name: 'Settings',
  components: {
    'connect': Connect,
    PageToolbar,
    Pill
  },
  data: function () {
    return {
      appsUrl: `https://${this.$domain}/admin/apps`,
      dailyNotifyLevel: 'Daily',
      email: null,
      plan: null,
      sendDailyEmail: false
    }
  },
  computed: {
    ...mapState(
      'ga',
      [
        'gaIntegration',
        'gaIsSetup',
        'gaShow'
      ]
    )
  },
  methods: {
    ...mapActions(
      'ga',
      [
        'loadGAIntegration'
      ]
    ),
    ...mapMutations(
      'ga',
      [
        'gaSetShow'
      ]
    ),
    handleToolbarBackButtonClick () {
      this.$router.go(-1)
    },
    toggleSendDailyEmail: function () {
      let sendDailyEmail = !this.sendDailyEmail

      this.user.notify_levels = this.user.notify_levels.filter(item => item !== this.dailyNotifyLevel)
      if (sendDailyEmail) {
        this.user.notify_levels.push(this.dailyNotifyLevel)
      }

      return axios({
        method: 'put',
        url: `users/${this.user.email}`,
        data: this.user
      })
      .then((response) => {
        this.sendDailyEmail = sendDailyEmail
      })
      .catch((error) => {
        console.log(error)
      })
    }
  },
  mounted () {
    this.loadUser().then(() => {
      this.email = this.user.email
      this.plan = this.$shop.plan_name === 'shopify_plus' ? 'Plus' : 'Standard'
      this.sendDailyEmail = this.user.notify_levels.includes(this.dailyNotifyLevel)
    })
    this.loadGAIntegration(this.$domain)
  }
}
</script>

<style lang="scss" scoped>
  .page-settings {
    padding: 20px 30px;
    @media screen and (min-width: 768px) {
      padding: 20px 46px;
    }
  }
  .email-link {
    color: #ADADAD;
    text-decoration: underline;
  }
  .settings {
    &-row {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding: 39px 0;
      border-bottom: 1px solid #e8e8e8;
      max-width: 640px;
      flex-direction: column;
      @media screen and (min-width: 768px) {
        flex-direction: row;
      }
      &:last-child {
        border-bottom: none;
      }
    }

    &-title {
      font-family: 'Roboto Bold';
      color: #000000;
      letter-spacing: 0;
      font-size: 40px;
      line-height: 1.3;
      @media screen and (min-width: 768px) {
        font-size: 50px;
        line-height: 45px;
      }
      width: 100%;
      margin-top: 37px;
      padding-bottom: 30px;
      border-bottom: 1px solid #e8e8e8;
    }

    &-eyebrow {
      font-family: 'Roboto';
      font-size: 15px;
      color: #000000;
      letter-spacing: 0;
      width: 100%;
      margin-bottom: 10px;
    }

    &-headline {
      font-family: 'Roboto Bold';
      font-size: 27px;
      line-height: 1.3;
      color: #000000;
      letter-spacing: 0;
      @media screen and (min-width: 768px) {
        font-size: 32px;
        line-height: 45px;
        margin-bottom: 0;
      }
    }

    &-pill {
      margin-top: 20px;
      @media screen and (min-width: 768px) {
        margin-left: auto;
        margin-top: 0;
      }
    }

    &-connect-btn {
      margin-top: 20px;
      border: 1px solid #9B9B9B;
      border-radius: 3px;
      background-color: transparent;
      padding: 10px 30px;
      min-width: 130px;
      font-family: 'Roboto Medium';
      font-size: 15px;
      color: #9B9B9B;
      letter-spacing: 0;
      text-align: center;
      line-height: 1.5;
      @media screen and (min-width: 768px) {
        margin-left: auto;
        margin-top: 0;
      }
      &:hover {
        background-color: #000;
        color: #fff;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/js/pages/Settings.vue